import PropTypes from "prop-types";
import React from "react";
import chroma from "chroma-js";

// Legible digit colour for a given dot background (dark bg → white, light → ink).
export const textOn = (bg) =>
  chroma(bg).luminance() > 0.5 ? "#1f2a30" : "#fff";

// A compact status counter: a leading icon + one coloured dot per status,
// mirroring UploadCounter's dots. `segments` = [{ label, value, color,
// filterValue? }]. When `onSelect` is given, non-empty dots become clickable and
// call onSelect(filterValue) — used to drive the site filters from the recap.
// `icon` is a node, not a class name: the field map has its own SVG asset and
// cannot be expressed as a FontAwesome class.
export const StatusCounter = ({ icon, segments, onSelect }) => (
  <span className="cf-uploads">
    {icon}
    {segments.map((segment) => {
      const clickable = Boolean(onSelect) && segment.filterValue != null;
      const select = () => onSelect(segment.filterValue);
      return (
        <span
          key={segment.label}
          className={"cf-uploads__dot" + (clickable ? " is-clickable" : "")}
          style={{ background: segment.color, color: textOn(segment.color) }}
          onClick={clickable ? select : undefined}
          role={clickable ? "button" : undefined}
          tabIndex={clickable ? 0 : undefined}
          onKeyDown={
            clickable
              ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    select();
                  }
                }
              : undefined
          }
          data-tooltip-id="tooltip"
          data-tooltip-content={`${segment.label}: ${segment.value}`}
        >
          {segment.value}
        </span>
      );
    })}
  </span>
);

StatusCounter.propTypes = {
  icon: PropTypes.node,
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      filterValue: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func,
};
